import React from 'react';

const PlaceholderLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <div className='bg-white flex flex-col h-screen overflow-hidden font-medium text-black'>
            <div className='flex-1 flex px-16 mb-5 overflow-hidden'>
                {children}
            </div>
        </div>
    );
};

export default PlaceholderLayout;